import { useState } from "react";
import Button from "../../Elements/Button/Button.js";
import apiRequest from "../../../utils/ApiRequest/apiRequest.js";
import LoaderContainer from "../../Reusable/LoaderContainer/LoaderContainer.js";
import { useContent } from "../../../contexts/contentContext/contentContext.js";
import { useToasts } from "react-toast-notifications";
import { useModal } from "../../../contexts/modalContext/modalContext.js";

const EditMailRegistration = ({ userData }) => {
  const { getTextByKey, getLanguageCulture } = useContent();
  const { closeModal } = useModal();
  const { addToast } = useToasts();
  const [newEmailAddress, setNewEmailAddress] = useState(userData.UserName);
  const [loading, setLoading] = useState(false);

  const EditRegistrationEmail = async () => {
    setLoading(true);
    const body = {
      UserNewEmail: newEmailAddress,
    };
    const response = await apiRequest(
      "Users",
      "EditRegistrationEmail",
      body,
      "POST"
    );
    if (response.status === "success") {
      if (response.data) {
        if (response.data === "OK") {
          addToast(getTextByKey("edit-email-success-alert"), {
            appearance: "success",
          });
          RegistrationResendConfirmationEmail();
        } else if (response.data === "GeneralError") {
          addToast(getTextByKey("edit-email-failed-alert"), {
            appearance: "error",
          });
        } else if (response.data === "EmailExists") {
          addToast(getTextByKey("edit-email-email-exist"), {
            appearance: "error",
          });
        } else if (response.data === "SameEmail") {
          addToast(getTextByKey("edit-email-same-email"), {
            appearance: "error",
          });
        }
      } else {
        addToast(getTextByKey("edit-email-failed-alert"), {
          appearance: "error",
        });
      }
    } else {
      addToast(getTextByKey("edit-email-failed-alert"), {
        appearance: "error",
      });
    }
    setLoading(false);
    closeModal();
  };
  const RegistrationResendConfirmationEmail = async () => {
    setLoading(true);
    const body = {
      UserCulture: getLanguageCulture(),
    };
    const response = await apiRequest(
      "Users",
      "RegistrationResendConfirmationEmail",
      body,
      "POST"
    );
    if (response.status === "success") {
      if (response.data) {
        addToast(getTextByKey("send-email-verify-success"), {
          appearance: "success",
        });
      } else {
        addToast(getTextByKey("send-email-verify-error"), {
          appearance: "error",
        });
      }
    } else {
      addToast(getTextByKey("send-email-verify-error"), {
        appearance: "error",
      });
    }
    setLoading(false);
    closeModal();
  };

  return (
    <div className="email-verify-modal-edit">
      <div className="top-section">
        <div className="modal-content">
          <div className="modal-body">
            <div>
              <p>{getTextByKey("incomplete-verify-email-text")}</p>
              <input
                placeholder={getTextByKey("incomplete-email-address")}
                value={newEmailAddress}
                type="text"
                onChange={(e) => setNewEmailAddress(e.target.value)}
              />
            </div>
            <div className="actions">
              <LoaderContainer isLoading={loading}>
                <Button
                  buttonClass="send-email-verify-button"
                  onClick={() => {
                    EditRegistrationEmail();
                  }}
                >
                  {getTextByKey("ok")}
                </Button>
              </LoaderContainer>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditMailRegistration;
